import useStore from '../zustand/useStore';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ButtonGroup,
  Button,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilter,
  faList,
  faBorderAll,
} from '@fortawesome/free-solid-svg-icons';

const FilterBarDailySchedule = () => {
  const {
   
    view,
    filters,   
    dateSessions,
    timeSessions,
    venues,
    meetingtypes,
    meetinggroups,
    datasetType,
    settings: {
      params: { displayviewswitch },
    },
    changeView,
    changeDataSet,
    setFilter,
  } = useStore((state) => ({
   
    view: state.view,
    filters: state.filters,   
    dateSessions: state.dateSessions,
    timeSessions: state.timeSessions,
    venues: state.venues,
    meetingtypes: state.meetingtypes,
    meetinggroups:state.meetinggroups,
    datasetType: state.datasetType,
    settings: state.settings,
    changeView: state.changeView,
    changeDataSet: state.changeDataSet,
    setFilter: state.setFilter,
  }));
  return (
    <Grid container style={{ width: '100%', margin: '3rem auto 0' }}>
      <Grid item xs={12} style={{ margin: '0 0 1rem' }}>
        {/* <strong>{rows.length}</strong> search results */}
      </Grid>
      <Grid
        item
        xs={8}
        style={{ paddingBottom: '1rem', borderBottom: '1px solid lightgrey' }}
      >
        <FontAwesomeIcon icon={faFilter}  />{' '}
        Filters
      </Grid>
      <Grid
        item
        xs={4}
        style={{
          paddingBottom: '1rem',
          borderBottom: '1px solid lightgrey',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
         <Button sx={{minWidth:90}} 
              variant={ datasetType === 'past' ? 'contained' : 'outlined'}
              onClick={() => changeDataSet()}
            >
              
              { datasetType === 'past' ? 'Upcoming Events' : 'Past Events'}
            
            </Button>
             {/* adding space */}
        {'\u00A0'}{'\u00A0'}{'\u00A0'}{'\u00A0'}
        {'\u00A0'}{'\u00A0'}{'\u00A0'}{'\u00A0'}
       

        {displayviewswitch === true && (
          <ButtonGroup variant="outlined" color="primary" disableRipple>
            <Button
              variant={view === 'card' ? 'contained' : 'outlined'}
              onClick={() => changeView('card')}
            >
              <FontAwesomeIcon
                icon={faBorderAll}
                style={{ marginRight: '.5rem', fontSize: '1.1rem' }}
              />
              Card view
            </Button>
            <Button
              variant={view === 'list' ? 'contained' : 'outlined'}
              onClick={() => changeView('list')}
            >
              <FontAwesomeIcon
                icon={faList}
                style={{ marginRight: '.5rem', fontSize: '1.1rem' }}
              />
              List view
            </Button>
          </ButtonGroup>
        )}
      </Grid>
      <Grid
        item
        xs={12}
        style={{ paddingBottom: '1rem', borderBottom: '1px solid lightgrey' }}
      >
        <Grid
          container
          spacing={3}
          style={{ marginTop: '-0.5rem', padding: '1rem 0' }}
        >
          
           {/* Meeting type filter */}
         <Grid item xs={2.5}>
            <FormControl variant="filled" fullWidth>
              <InputLabel id="meeting-type-filter-label">Meeting type</InputLabel>
              <Select
                variant="filled"
                id="meeting-type-filter"
                labelId="meeting-type-filter-select-label"
                value={filters.MeetingType}
                disabled={filters.MeetingType.length > 0}
                onChange={(e) => {
                  setFilter('MeetingType', e.target.value);
                }}
              >
                {meetingtypes &&
                  meetingtypes.map((meetingtype) => {
                    return (
                      <MenuItem key={meetingtype} value={meetingtype}>
                        {meetingtype}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>

          
           {/* Meeting groups (committee) filter */}
         <Grid item xs={2.5}>
            <FormControl variant="filled" fullWidth>
              <InputLabel id="meeting-groups-filter-label">Committee</InputLabel>
              <Select
                variant="filled"
                id="meeting-groups-select-filter"
                labelId="meeting-groups-select-filter-label"
                value={filters.MeetingGroup}
                disabled={filters.MeetingGroup.length > 0}
                onChange={(e) => {
                  setFilter('MeetingGroup', e.target.value);
                }}
              >
                {meetinggroups &&
                  meetinggroups.map((meetinggroup) => {
                    return (
                      <MenuItem key={meetinggroup} value={meetinggroup}>
                        {meetinggroup}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>
        
          {/* Date filter */}
          <Grid item xs={2.5}>
            <FormControl variant="filled" fullWidth>
              <InputLabel id="date-filter-label">Date</InputLabel>
              <Select
                variant="filled"
                id="date-filter"
                labelId="date-filter-label"
                value={filters.DateSession}
                disabled={filters.DateSession.length > 0}
                onChange={(e) => {
                  setFilter('DateSession', e.target.value);
                }}
              >


                {dateSessions &&
                  dateSessions.map((dateSession, index) => {                    
                    //console.log(dateSession)
                    return (
                      <MenuItem key={index} value={dateSession}>
                        {dateSession}
                      </MenuItem>
                    );                    
                  })}
              </Select>
            </FormControl>
          </Grid>

          {/* Time filter */}
          <Grid item xs={2}>
            <FormControl variant="filled" fullWidth>
              <InputLabel id="time-filter-label">Time</InputLabel>
              <Select
                variant="filled"
                id="time-filter"
                labelId="time-filter-label"
                value={filters.TimeSession}
                disabled={filters.TimeSession.length > 0}
                onChange={(e) => {
                  setFilter('TimeSession', e.target.value);
                }}
              >
                {timeSessions &&
                  timeSessions.map((timeSession) => {
                    return (
                      <MenuItem key={timeSession} value={timeSession}>
                        {timeSession}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>
        

         {/* Venue filter */}
         <Grid item xs={2.5}>
            <FormControl variant="filled" fullWidth>
              <InputLabel id="venue-filter-label">Venue</InputLabel>
              <Select
                variant="filled"
                id="venue-filter"
                labelId="venue-filter-label"
                value={filters.Venue}
                disabled={filters.Venue.length > 0}
                onChange={(e) => {
                  setFilter('Venue', e.target.value);
                }}
              >
                {venues &&
                  venues.map((venue) => {
                    return (
                      <MenuItem key={venue} value={venue}>
                        {venue}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>


        </Grid>
      </Grid>
    </Grid>
  );
};

export default FilterBarDailySchedule;
